// extracted by mini-css-extract-plugin
module.exports = {"auth-login-button":"AuthButton_auth-login-button__29-fE","text":"AuthButton_text__2mpT6","auth-register-button":"AuthButton_auth-register-button__1rBLA"};